<h1 mat-dialog-title class="textFont">{{getTitle()}}</h1>
<div mat-dialog-content>
    <div *ngIf="data.success; then thenBlock else elseBlock"></div>
    <ng-template #thenBlock><p class="textFont">An email has been sent to {{data.email}}, please follow the instructions to reset your password.</p></ng-template>
    <ng-template #elseBlock><p class="textFont">{{data.errorMessage}}</p></ng-template>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()" class="btn-center">Continue</button>
</div>